import React, { useEffect } from 'react'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import notFoundImage from 'images/not-found.png'
import { TonalButton } from 'components/empty-page-state'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: theme.spacing(17),
    background: theme.palette.common.white,
    height: '100vh',
    width: '100%',
  },
  errorImg: {
    width: '100%',
  },
}))

export default ({ statusCode = 500, error, message, showHeading = true }) => {
  const classes = useStyles()

  useEffect(() => {
    if (error) {
      window.rg4js && window.rg4js('send', { error })
    }
  }, [error])

  let errorMessage
  switch (statusCode) {
    case 404:
      errorMessage =
        "Even the best golfers lose one now and then. This page couldn't be found."
      break
    case 500:
    default:
      errorMessage = "Sorry, something went wrong. We're looking into it."
      break
  }

  return (
    <div className={classes.root} data-testid="error-page">
      {showHeading && (
        <Typography align="center" variant="h3" gutterBottom>
          Fore!
        </Typography>
      )}
      <Typography align="center" variant="body1">
        {message || errorMessage}
      </Typography>
      <Box mb={8} maxWidth="420px">
        <img alt="error-img" className={classes.errorImg} src={notFoundImage} />
      </Box>
      <Box align="center">
        <TonalButton to="/">Return home</TonalButton>
      </Box>
    </div>
  )
}
